<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <div :class="[deviceType, 'title']">
      <span v-if="prop.resumeApplication">
        <h1>{{ t("ccOnBoarding.resume.personalInfoTitle") }}</h1>
        <p>{{ t("ccOnBoarding.resume.personalInfoDesc") }}</p>
      </span>
      <span v-else>
        <h1>{{ t("ccOnBoarding.resume.personalInfoTitle2") }}</h1>
        <p>{{ t("ccOnBoarding.resume.personalInfoDesc2") }}</p>
      </span>
    </div>

    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div v-if="showForm" :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div
            v-if="prop.resumeApplication"
            class="buttonGroup"
            :class="{ hideBtn: prop.type == 'CR_SL' }"
          >
            <div
              class="button_toggle"
              @click="toggle('customer')"
              :class="[ccFormValue.activeButton == 'customer' ? 'active' : '']"
            >
              <p>{{ t("ccOnBoarding.resume.customer") }}</p>
            </div>
            <div
              class="button_toggle"
              @click="toggle('staff')"
              :class="[ccFormValue.activeButton == 'staff' ? 'active' : '']"
            >
              <p>{{ t("ccOnBoarding.resume.acsmStaff") }}</p>
            </div>
          </div>
          <div v-if="ccFormValue.activeButton == 'customer'">
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'flex_dropdown']">
                <DropDown
                  v-model="prop.resumeInfo.idType"
                  :selectedOption="prop.resumeInfo.idType"
                  :options="idTypeList"
                  :value="idTypeList"
                  field="idType"
                  :placeholder="t('ccOnBoarding.basicInformation.idType')"
                  :disabled="prop.type == 'CR_SL'"
                />
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <InputText
                  ref="idNoInput"
                  class="inputcomponent"
                  v-model="prop.resumeInfo.idNo"
                  :value="prop.resumeInfo.idNo"
                  :field="'idNo'"
                  :required="false"
                  :placeholder="
                    prop.resumeInfo.idType == '1'
                      ? t('ccOnBoarding.basicInformation.passportNumber')
                      : prop.resumeInfo.idType != '1' &&
                          prop.resumeInfo.idType != ''
                        ? t('ccOnBoarding.resume.NRIC')
                        : t('ccOnBoarding.basicInformation.icPassportNumber')
                          ? t('ccOnBoarding.basicInformation.icPassportNumber')
                          : t('ccOnBoarding.basicInformation.icPassportNumber')
                  "
                  :max-length="12"
                  :autocomplete="'new-password'"
                  :pattern="computedPattern"
                  :number="
                    prop.resumeInfo.idType === '0' ||
                    prop.resumeInfo.idType === '2' ||
                    prop.resumeInfo.idType === '3'
                      ? 'true'
                      : 'false'
                  "
                  @keydown="handleKeyDown('', $event)"
                  :clear="isClear"
                  :idType="prop.resumeInfo.idType"
                  :type="'text'"
                  :inputmode="
                    prop.resumeInfo.idType != '1' ? 'numeric' : 'text'
                  "
                  :disabled="
                    prop.verification == 'true' || prop.type == 'CR_SL'
                      ? true
                      : false
                  "
                />
              </div>
            </div>
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  v-if="prop.resumeApplication"
                  class="inputcomponent"
                  v-model="prop.resumeInfo.email"
                  field="email"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.email')"
                  :max-length="100"
                  :autocomplete="'new-password'"
                  :noCapital="true"
                />
                <InputText
                  v-else
                  class="inputcomponent"
                  v-model="prop.resumeInfo.email"
                  field="email"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.email')"
                  :max-length="100"
                  :autocomplete="'new-password'"
                  :noCapital="true"
                  :disabled="
                    prop.autoPopulationOtp.otpMobile.status === 'falseOtp' ||
                    prop.autoPopulationOtp.otpEmail.validated ||
                    prop.type == 'CR_SL'
                  "
                />
              </div>
            </div>
            <div :class="[deviceType, 'container3']">
              <div :class="[deviceType, 'flex_third']">
                <DropDown
                  v-if="prop.resumeApplication"
                  v-model="prop.resumeInfo.countryCode"
                  :selectedOption="prop.resumeInfo.countryCode"
                  :options="mobileCountryCodeList.slice(0, 2)"
                  :value="mobileCountryCodeList.slice(0, 2)"
                  :default="true"
                  :default-value="'60'"
                  field="countryCode"
                  :placeholder="
                    deviceType != 'Mobile'
                      ? t('ccOnBoarding.basicInformation.countryCode')
                      : ''
                  "
                  :is-country-code="true"
                />
                <DropDown
                  v-else
                  v-model="prop.resumeInfo.countryCode"
                  :selectedOption="prop.resumeInfo.countryCode"
                  :options="mobileCountryCodeList.slice(0, 2)"
                  :value="mobileCountryCodeList.slice(0, 2)"
                  :default="true"
                  :default-value="'60'"
                  field="countryCode"
                  :placeholder="
                    deviceType != 'Mobile'
                      ? t('ccOnBoarding.basicInformation.countryCode')
                      : ''
                  "
                  :disabled="
                    prop.autoPopulationOtp.otpEmail.status === 'falseEmail' ||
                    prop.autoPopulationOtp.otpMobile.validated ||
                    prop.type == 'CR_SL'
                  "
                  :is-country-code="true"
                />
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <InputText
                  v-if="prop.resumeApplication"
                  class="inputcomponent"
                  v-model="prop.resumeInfo.mobileNo"
                  field="mobileNo"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.mobileNo')"
                  :max-length="prop.resumeInfo.countryCode == '65' ? 9 : 10"
                  :min-length="prop.resumeInfo.countryCode == '65' ? 8 : 9"
                  :autocomplete="'new-password'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                  :number="'true'"
                  :type="'text'"
                  :pattern="'[0-9]*'"
                  :inputmode="'numeric'"
                  :trim="true"
                  @keydown.enter.prevent="handleEnterKey"
                />
                <InputText
                  v-else
                  class="inputcomponent"
                  v-model="prop.resumeInfo.mobileNo"
                  field="mobileNo"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.mobileNo')"
                  :max-length="prop.resumeInfo.countryCode == '65' ? 9 : 10"
                  :min-length="prop.resumeInfo.countryCode == '65' ? 8 : 9"
                  :autocomplete="'new-password'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                  :number="'true'"
                  :type="'text'"
                  :pattern="'[0-9]*'"
                  :inputmode="'numeric'"
                  :trim="true"
                  @keydown.enter.prevent="handleEnterKey"
                  :disabled="
                    prop.autoPopulationOtp.otpEmail.status === 'falseEmail' ||
                    prop.autoPopulationOtp.otpMobile.validated ||
                    prop.type == 'CR_SL'
                  "
                />
              </div>
            </div>
            <div class="bottomLine"></div>
          </div>
          <div v-else>
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  ref="idNoInput"
                  class="inputcomponent"
                  v-model="prop.resumeInfo.idNo"
                  :value="prop.resumeInfo.idNo"
                  :field="'staffResumedIdNo'"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.basicInformation.icPassportNumber')
                  "
                  :max-length="12"
                  :autocomplete="'new-password'"
                  :pattern="computedPattern"
                  :number="'false'"
                  @keydown="handleKeyDown('', $event)"
                  :clear="isClear"
                  :type="'text'"
                  :inputmode="'text'"
                  :disabled="bioDisabledIdNo"
                  :custom-placeholder="staffResumedPlaceholder1"
                  @keydown.enter.prevent="handleEnterKey"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.resumeInfo.referenceNumber"
                  field="referenceNo"
                  :required="false"
                  :placeholder="t('ccOnBoarding.sendBack.referenceNumber')"
                  :max-length="22"
                  :autocomplete="'new-password'"
                  :custom-placeholder="sendBackPlaceholder1"
                  @keydown="handleKeyDown('referenceNo', $event)"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  ref="idNoInput"
                  class="inputcomponent"
                  v-model="prop.resumeInfo.recruiterId"
                  :value="prop.resumeInfo.recruiterId"
                  :field="'resumedRecruiterId'"
                  :required="false"
                  :placeholder="t('ccOnBoarding.biometric.recruiterId')"
                  :type="'text'"
                  :inputmode="'text'"
                  :max-length="10"
                  :autocomplete="'new-password'"
                  :disabled="bioDisabledRCI"
                  :custom-placeholder="staffResumedPlaceholder2"
                  @keydown="handleNameKeyDown"
                  @keydown.enter.prevent="handleEnterKey"
                />
              </div>
            </div>

            <div class="bottomLine">
              <div v-if="invalidReferenceNo">
                <div class="noFurtherFileContainer1">
                  <div class="noFurtherFileSubContainer1">
                    {{ t("ccOnBoarding.resume.invalidReferenceNo") }}
                  </div>
                </div>
              </div>

              <div v-if="expiredApplication">
                <div class="noFurtherFileContainer1">
                  <div class="noFurtherFileSubContainer1">
                    {{ t("ccOnBoarding.resume.expiredApplication") }}
                  </div>
                </div>
              </div>

              <div v-if="invalidBranch">
                <div class="noFurtherFileContainer1">
                  <div class="noFurtherFileSubContainer1">
                    {{ t("ccOnBoarding.resume.invalidBranch") }}
                  </div>
                </div>
              </div>

              <div v-if="invalidRecruiter">
                <div class="noFurtherFileContainer1">
                  <div class="noFurtherFileSubContainer1">
                    {{ t("ccOnBoarding.resume.invalidRecruiter") }}
                  </div>
                </div>
              </div>

              <div v-if="invalidChannel">
                <div class="noFurtherFileContainer1">
                  <div class="noFurtherFileSubContainer1">
                    {{ t("ccOnBoarding.resume.invalidChannel") }}
                  </div>
                </div>
              </div>

              <div v-if="mismatchID">
                <div class="noFurtherFileContainer2">
                  <div class="noFurtherFileSubContainer2">
                    {{ t("ccOnBoarding.resume.mismatchID") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showForm" :class="[deviceType, 'buttoncontainer']">
        <button
          :class="[deviceType, 'left-button']"
          type="button"
          @click="handleBack"
        >
          {{ t("ccOnBoarding.resume.buttonBack") }}
        </button>
        <button :class="[deviceType, 'right-button']" :disabled="isBtnDisabled">
          {{ t("ccOnBoarding.resume.buttonProceed") }}
        </button>
      </div>
    </Form>
    <div v-if="showRetrieve">
      <div :class="[deviceType, 'retrieveContainer']">
        <div class="text-center flex-container">
          <br />
          <div class="spinner-border" role="status">
            <span class="sr-only">{{
              t("ccOnBoarding.uploadDocument.loading2")
            }}</span>
          </div>
          <br />
          <br />
          <p class="loading">
            <b>{{ t("ccOnBoarding.resume.retrieving") }}</b>
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div v-if="isSubmitError">
      <div :class="[deviceType, 'retrieveContainer']" class="error">
        <div class="retry">
          <img
            class="path-65 retry_logo"
            src="../../../../assets/icons/bio_timeout.svg"
          />
          <p>{{ t("ccOnBoarding.resume.connectionTimeout") }}</p>
        </div>
        <div :class="[deviceType, 'buttoncontainer2']">
          <div :class="[deviceType, 'left-button2']" @click="startApplication">
            {{ t("ccOnBoarding.resume.buttonStart") }}
          </div>
          <button :class="[deviceType, 'right-button2']" @click="onSubmit">
            {{ t("ccOnBoarding.resume.buttonRetry") }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <PopupMessage
    name="none"
    :type="''"
    :header="'draftFound'"
    v-if="popoutDraftFound"
    :popup="true"
    @resumeApplication="resumeApplication"
    @startNewApplication="startNewApplication"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import { ref, computed, watch, onBeforeMount, type PropType } from "vue";
import i18n from "@/plugin/i18n";
import { inject } from "vue";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import DropDown from "./../components/NewDropDownComponent.vue";
import InputText from "./../components/NewInputTextComponent.vue";
import { Form } from "vee-validate";
import type FormCCOtp from "@/interface/FormCCOtp";
import type AutoPopulatePersonalInfo from "@/interface/AutoPopulatePersonalInfo";
import Headers from "./../components/Headers.vue";
import PopupMessage from "./../components/PopupMessage.vue";
import { useRouter } from "vue-router";

const deviceType = inject("deviceType");
const { t } = i18n.global;
const router = useRouter();

const showForm = ref(true);
const showRetrieve = ref(false);
const isSubmitError = ref(false);
const popoutDraftFound = ref(false);
const recruiterEligible = ref("");
const isClear = ref("false");
const bioDisabledIdNo = ref(false);
const bioDisabledRCI = ref(false);

const invalidReferenceNo = ref(false);
const expiredApplication = ref(false);
const invalidBranch = ref(false);
const invalidRecruiter = ref(false);
const invalidChannel = ref(false);
const mismatchID = ref(false);
const referenceNoEligible = ref("");

const sendBackPlaceholder1 = i18n.global.t(
  "ccOnBoarding.sendBack.placeholder1",
);
const staffResumedPlaceholder1 = i18n.global.t(
  "ccOnBoarding.sendBack.placeholder3",
);
const staffResumedPlaceholder2 = i18n.global.t(
  "ccOnBoarding.sendBack.placeholder4",
);

interface IdType {
  code: string;
  value: string;
}

let mobileCountryCodeList = ref([]);
let idTypeList = ref<IdType[]>([]);

const autoPopulatePersonalInfo = ref<AutoPopulatePersonalInfo>({
  email: "",
  countryCode: "",
  mobileNo: "",
});

const prop = defineProps({
  resumeApplication: {
    type: Boolean,
    required: true,
  },
  resumeInfo: {
    type: Object,
    required: true,
  },
  resumeDraftData: {
    type: Object,
    required: true,
  },
  recruiterId: {
    type: String,
  },
  ccFormValue: {
    type: Object,
    required: true,
  },
  verification: {
    type: String,
    required: true,
  },
  type: {
    type: String,
  },
  cardId: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
  biometricCardList: {
    type: Object,
  },
  biometricStartInfo: {
    type: Object,
    required: true,
  },
  resumeOtp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
  autoPopulationOtp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
});

onBeforeMount(() => {
  MasterService.getMasterData()
    .then((res) => {
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
      idTypeList.value = res.data.idType;

      if (prop.type == "BIO" && prop.webFormRequestId) {
        idTypeList.value = idTypeList.value.filter(
          (id) => id.value !== "Passport",
        );
      }
    })
    .catch((e) => {});

  if (prop.type == "BIO") {
    prop.resumeInfo.recruiterId = prop.biometricStartInfo.recruiterId;
    bioDisabledRCI.value = true;
  }

  if (prop.type == "BIO" && prop.webFormRequestId && prop.biometricCardList) {
    // bio unique link
    prop.resumeInfo.idNo = prop.biometricCardList.nric;
    bioDisabledIdNo.value = true;
  }

  // check is back from populate otp ?
  if (
    prop.autoPopulationOtp.otpEmail.validated ||
    prop.autoPopulationOtp.otpMobile.validated ||
    prop.type == "CR_SL"
  ) {
    autoPopulatePersonalInfo.value.countryCode = prop.resumeInfo.countryCode;
    autoPopulatePersonalInfo.value.mobileNo = prop.resumeInfo.mobileNo;
    autoPopulatePersonalInfo.value.email = prop.resumeInfo.email;
  }
});

const computedPattern = computed(() => /^\d+$/);

const handleKeyDown = (field: string, event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";

  const isSymbol = /[^\w\d_]/.test(event.key); // true for symbol input

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }

  invalidReferenceNo.value = false;
  expiredApplication.value = false;
  invalidBranch.value = false;
  invalidChannel.value = false;
  mismatchID.value = false;

  if (field == "referenceNo") {
    referenceNoEligible.value = "";
  }
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  // const isSymbol = /[^\sa-zA-Z_]/.test(event.key);
  const isSymbol = /^[a-zA-Z0-9]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
  invalidRecruiter.value = false;
  recruiterEligible.value = "true";
};

const isBtnDisabled = computed(() => {
  return prop.ccFormValue.activeButton == "customer"
    ? prop.resumeInfo.idType.length == 0 ||
        prop.resumeInfo.idNo.length == 0 ||
        prop.resumeInfo.email.length == 0 ||
        prop.resumeInfo.countryCode.length == 0 ||
        prop.resumeInfo.mobileNo.length == 0
    : prop.resumeInfo.referenceNumber.length == 0 ||
        prop.resumeInfo.idNo.length == 0;
});

const onSubmit = () => {
  if (prop.type == "CR_SL") {
    // in case user edit
    prop.resumeInfo.countryCode = autoPopulatePersonalInfo.value.countryCode;
    prop.resumeInfo.mobileNo = autoPopulatePersonalInfo.value.mobileNo;
    prop.resumeInfo.email = autoPopulatePersonalInfo.value.email;
    emit("jumpStep", 106, "", 4);
  } else if (prop.ccFormValue.activeButton == "customer") {
    showForm.value = false;
    isSubmitError.value = false;
    showRetrieve.value = true;

    prop.resumeInfo.isResumedByStaff = false;
    const requestModel2 = {
      idTypeCode: prop.resumeInfo.idType,
      idNo: prop.resumeInfo.idNo,
      email: prop.resumeInfo.email,
      mobileNo: prop.resumeInfo.countryCode + prop.resumeInfo.mobileNo,
      recruiterCode: prop.recruiterId
        ? prop.recruiterId != "NA"
          ? prop.recruiterId
          : ""
        : "",
    };
    MasterService.fetchRecords(requestModel2)
      .then((res) => {
        if (res.status == 200) {
          if (!prop.resumeApplication) {
            if (res.data.responseModel.draftData > 0) {
              prop.resumeDraftData.length = 0;
              for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
                prop.resumeDraftData.push({
                  branchCode: res.data.responseModel.cardList[i].branchCode,
                  cardId: res.data.responseModel.cardList[i].cardId,
                  cardType: res.data.responseModel.cardList[i].cardType,
                  createdDate: res.data.responseModel.cardList[i].createdDate,
                  progress: res.data.responseModel.cardList[i].progress,
                  type: res.data.responseModel.cardList[i].type,
                  reference: res.data.responseModel.cardList[i].refNo,
                  webFormRequestId:
                    res.data.responseModel.cardList[i].webFormRequestId,
                  merchantCode: res.data.responseModel.cardList[i].merchantCode,
                  acc: res.data.responseModel.cardList[i]
                    .applicationChannelCode,
                });
              }
              showForm.value = true;
              showRetrieve.value = false;
              popoutDraftFound.value = true;
            } else {
              // no resume draft
              const requestModel = {
                idType: prop.resumeInfo.idType,
                idNo: prop.resumeInfo.idNo,
                mobileCountryCode: prop.resumeInfo.countryCode,
                mobileNumber: prop.resumeInfo.mobileNo,
                emailAddress: prop.resumeInfo.email,
              };
              MasterService.searchCIF(requestModel)
                .then((res) => {
                  if (res.status == 200) {
                    showForm.value = true;
                    showRetrieve.value = false;
                    if (res.data.responseModel.cifVerify == "true") {
                      // existing customer
                      prop.ccFormValue.cifNo = res.data.responseModel.cifNo;

                      // check whether edit personal info
                      if (
                        prop.autoPopulationOtp.otpEmail.validated ||
                        prop.autoPopulationOtp.otpMobile.validated
                      ) {
                        if (
                          !(
                            autoPopulatePersonalInfo.value.countryCode ==
                              prop.resumeInfo.countryCode &&
                            autoPopulatePersonalInfo.value.mobileNo ==
                              prop.resumeInfo.mobileNo &&
                            autoPopulatePersonalInfo.value.email ==
                              prop.resumeInfo.email
                          )
                        ) {
                          // edited, then reset two otp status
                          emit("resetAutoPopulationOtp");
                        }
                      }
                      emit("jumpStep", 106, "", 4);
                    } else {
                      // non-existing customer
                      emit("newApplication");

                      if (
                        (prop.cardId == "NA" || prop.cardId == "") &&
                        prop.type !== "BIO"
                      ) {
                        emit("jumpStep", 0, "", 4);
                      } else emit("jumpStep", 1, "", 4);
                    }
                  }
                })
                .catch((e) => {
                  emit("newApplication");
                  if (
                    (prop.cardId == "NA" || prop.cardId == "") &&
                    prop.type !== "BIO"
                  ) {
                    emit("jumpStep", 0, "", 4);
                  } else emit("jumpStep", 1, "", 4);
                });
            }
          } else {
            showForm.value = true;
            showRetrieve.value = false;
            if (res.data.responseModel.draftData == 0)
              emit("jumpStep", 104, "", 4);
            else {
              prop.resumeDraftData.length = 0;
              for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
                prop.resumeDraftData.push({
                  branchCode: res.data.responseModel.cardList[i].branchCode,
                  cardId: res.data.responseModel.cardList[i].cardId,
                  cardType: res.data.responseModel.cardList[i].cardType,
                  createdDate: res.data.responseModel.cardList[i].createdDate,
                  progress: res.data.responseModel.cardList[i].progress,
                  type: res.data.responseModel.cardList[i].type,
                  reference: res.data.responseModel.cardList[i].refNo,
                  webFormRequestId:
                    res.data.responseModel.cardList[i].webFormRequestId,
                  recruiterName:
                    res.data.responseModel.cardList[i].recruiterName,
                  merchantCode: res.data.responseModel.cardList[i].merchantCode,
                  acc: res.data.responseModel.cardList[i]
                    .applicationChannelCode,
                });
              }
              if (prop.type == "BIO" && prop.verification == "true")
                emit("jumpStep", 105, "", 4);
              else emit("jumpStep", 103, "personalInfo", 4);
            }
          }
        }
      })
      .catch((e) => {
        showForm.value = false;
        showRetrieve.value = false;
        isSubmitError.value = true;
      });
  } else {
    if (
      invalidReferenceNo.value == true ||
      expiredApplication.value == true ||
      invalidBranch.value == true ||
      invalidRecruiter.value == true ||
      invalidChannel.value == true ||
      mismatchID.value == true
    ) {
      return;
    }

    showForm.value = false;
    isSubmitError.value = false;
    showRetrieve.value = true;

    const requestModel2 = {
      idNo: prop.resumeInfo.idNo,
      refNo: prop.resumeInfo.referenceNumber,
      recruiterCode:
        prop.type == "BIO"
          ? prop.biometricStartInfo.recruiterId
          : prop.resumeInfo.recruiterId,
    };

    MasterService.staffFetchRecords(requestModel2)
      .then((res) => {
        if (res.status == 200) {
          showForm.value = true;
          showRetrieve.value = false;
          if (res.data.responseModel.status == "E007") {
            invalidReferenceNo.value = true;
            referenceNoEligible.value = "false";
            invalidReference();
          } else if (res.data.responseModel.status == "E006") {
            expiredApplication.value = true;
          } else if (res.data.responseModel.status == "E004") {
            invalidBranch.value = true;
          } else if (res.data.responseModel.status == "E008") {
            invalidRecruiter.value = true;
          } else if (res.data.responseModel.status == "E005") {
            invalidChannel.value = true;
          } else if (res.data.responseModel.status == "E001") {
            mismatchID.value = true;
          } else if (res.data.responseModel.status == "E003") {
            recruiterEligible.value = "false";
          } else if (res.data.responseModel.draftData == 1) {
            prop.resumeInfo.isResumedByStaff = true;
            prop.resumeInfo.recruiterName =
              res.data.responseModel.resumedStaffName;
            if (prop.verification == "true") {
              // bio unique link skip otp
              router.push({
                name: "CCProgressRoutePage",
                state: {
                  draftListing: true,
                  resumedByRecruiterId: prop.resumeInfo.recruiterId,
                  resumedByRecruiterName: prop.resumeInfo.recruiterName,
                },
                query: {
                  webFormRequestId:
                    res.data.responseModel.cardList[0].webFormRequestId,
                },
              });
            } else if (
              res.data.responseModel.cardList[0].ekycStatus == "COMPLETE" ||
              res.data.responseModel.cardList[0].biometricVerification == true
            ) {
              // done ekyc or bio flag is true, then skip otp
              router.push({
                name: "CCProgressRoutePage",
                state: {
                  draftListing: true,
                  resumedByRecruiterId: prop.resumeInfo.recruiterId,
                  resumedByRecruiterName: prop.resumeInfo.recruiterName,
                },
                query: {
                  webFormRequestId:
                    res.data.responseModel.cardList[0].webFormRequestId,
                },
              });
            } else {
              // go to resume otp page
              prop.resumeInfo.webFormRequestId =
                res.data.responseModel.cardList[0].webFormRequestId;
              prop.resumeInfo.countryCode =
                res.data.responseModel.cardList[0].webFormDetails.basicInformation.mobileCountryCode;
              prop.resumeInfo.mobileNo =
                res.data.responseModel.cardList[0].webFormDetails.basicInformation.mobileNumber;
              prop.resumeInfo.email =
                res.data.responseModel.cardList[0].webFormDetails.basicInformation.emailAddress;
              emit("jumpStep", 103, "personalInfo", 4);
            }
          }
        }
      })
      .catch((e) => {
        showForm.value = false;
        showRetrieve.value = false;
        isSubmitError.value = true;
      });
  }
};

const handleBack = () => {
  if (prop.type == "BIO") emit("jumpStep", 16, "", 4);
  else emit("jumpStep", 101, "", 4);
};

const toggle = (status: string) => {
  prop.ccFormValue.activeButton = status;
};

const schema = computed(() => {
  const countryCodeSelected = prop.resumeInfo.countryCode == "60";
  const idNoIcFormat = prop.resumeInfo.idType != "1";
  const idNoPassportFormat = prop.resumeInfo.idType == "1";
  return prop.ccFormValue.activeButton == "customer"
    ? {
        idType: "required",
        idNo:
          prop.ccFormValue.activeButton == "customer"
            ? idNoIcFormat
              ? "required|minLengthNumber:12|icNo|numberFormat"
              : idNoPassportFormat
                ? "required|minLengthNumber:8|maxLengthNumber:12"
                : ""
            : "required|minLengthNumber:8|maxLengthNumber:12",
        email: "required|email",
        mobileNo: countryCodeSelected
          ? "requiredNumber|minLengthNumber:9|maxLengthNumber:10|numberFormat"
          : "requiredNumber|minLengthNumber:8|maxLengthNumber:9|numberFormat",
      }
    : {
        staffResumedIdNo:
          prop.ccFormValue.activeButton == "customer"
            ? idNoIcFormat
              ? "required|minLengthNumber:12|icNo|numberFormat"
              : idNoPassportFormat
                ? "required|minLengthNumber:8|maxLengthNumber:12"
                : ""
            : "required|minLengthNumber:8|maxLengthNumber:12",
        referenceNo:
          referenceNoEligible.value != "false"
            ? "required|fixedLength:22|referenceNo"
            : "invalidReferenceNo",
        resumedRecruiterId:
          recruiterEligible.value != "false"
            ? "required"
            : "invalidRecruiterId",
      };
});

const onInvalidSubmit = () => {};

const emit = defineEmits([
  "jumpStep",
  "newApplication",
  "resetAutoPopulationOtp",
]);

const handleEnterKey = () => {};

const resumeApplication = () => {
  popoutDraftFound.value = false;
  emit("jumpStep", 103, "personalInfo", 4);
};

const startApplication = () => {
  showForm.value = true;
  showRetrieve.value = false;
  isSubmitError.value = false;
  emit("jumpStep", 102, "start", 4);
};

const startNewApplication = () => {
  popoutDraftFound.value = false;
  const requestModel = {
    idType: prop.resumeInfo.idType,
    idNo: prop.resumeInfo.idNo,
    mobileCountryCode: prop.resumeInfo.countryCode,
    mobileNumber: prop.resumeInfo.mobileNo,
    emailAddress: prop.resumeInfo.email,
  };
  MasterService.searchCIF(requestModel)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.responseModel.cifVerify == "true") {
          // existing customer
          prop.ccFormValue.cifNo = res.data.responseModel.cifNo;

          // check whether edit personal info
          if (
            prop.autoPopulationOtp.otpEmail.validated ||
            prop.autoPopulationOtp.otpMobile.validated
          ) {
            if (
              !(
                autoPopulatePersonalInfo.value.countryCode ==
                  prop.resumeInfo.countryCode &&
                autoPopulatePersonalInfo.value.mobileNo ==
                  prop.resumeInfo.mobileNo &&
                autoPopulatePersonalInfo.value.email == prop.resumeInfo.email
              )
            ) {
              // edited, then reset two otp status
              emit("resetAutoPopulationOtp");
            }
          }
          emit("jumpStep", 106, "", 4);
        } else {
          // non-existing customer
          emit("newApplication");
          if (
            (prop.cardId == "NA" || prop.cardId == "") &&
            prop.type !== "BIO"
          ) {
            emit("jumpStep", 0, "", 4);
          } else emit("jumpStep", 1, "", 4);
        }
      }
    })
    .catch((e) => {
      emit("newApplication");
      if ((prop.cardId == "NA" || prop.cardId == "") && prop.type !== "BIO") {
        emit("jumpStep", 0, "", 4);
      } else emit("jumpStep", 1, "", 4);
    });
};

async function invalidReference() {
  schema.value.referenceNo = "invalidReferenceNo";
}
</script>

<style scoped>
h1 {
  color: var(--Web-Black-High, #212121);

  /* Custom 3 */
  font-family: Outfit;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 31.2px */
}

p {
  color: var(--Web-Black-Medium, #757575);

  /* Body (Regular) */
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}

.title:is(.Mobile) {
  padding: 20px 16px 0 16px;
}

.retrieveContainer:is(.Mobile) {
  width: 90%;
  padding: 80px 0;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.content:is(.Mobile) {
  padding: 0;
}

.container3,
.container4 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
}

.bottomLine {
  border-bottom: 1px solid #e4e4e4;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.container4:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.inner:is(.Mobile) {
  padding: 0 20px;
}

.inputText {
  margin-bottom: 14px;
  width: 100%;
}

.flex_third {
  width: 30%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.flex_inputText {
  width: 70%;
}

.flex_inputText:is(.Mobile) {
  width: 100%;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 0 8%;
}

.buttoncontainer:is(.Mobile) {
  /* flex-wrap: wrap;
  display: flex;
  justify-content: space-between; */
  align-items: center;
  padding: 0 20px;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.left-button {
  flex: 0 0 15%;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
  /* display: none; */
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:is(.Mobile):disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 68%;
}

.retrieveContainer {
  display: flex;
  width: 50%;
  height: 50%;
  padding: 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 16px;
  background: #fff;
  /* box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.24); */
  margin: 60px auto;
}

.retrieveContainer.error {
  align-items: normal;
  padding: 40px;
}

.retrieveContainer:is(.Mobile).error {
  padding: 0;
}

.flex-container {
  margin: auto;
}

.loading {
  margin-bottom: 0;
  color: var(--Web-Black-High, #212121);
  text-align: center;

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

.spinner-border {
  width: 5rem;
  height: 5rem;
}

.retry p {
  color: var(--Web-Black-High, #212121);
  text-align: center;

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

.retry_logo {
  width: 160px;
  height: 160px;
  display: flex;
  margin: auto;
}

@media (max-width: 1170px) {
  .retrieveContainer {
    width: 80%;
  }
}

@media (max-width: 700px) {
  .container4:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 0;
  }

  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
    /* display: none; */
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .retrieveContainer {
    width: 100%;
  }
}

.buttoncontainer2 {
  display: flex;
  align-items: center;
  margin-top: 24px;
}

.buttoncontainer2:is(.Desktop, .Tablet) {
  gap: 16px;
}

.buttoncontainer2:is(.Mobile) {
  /* flex-wrap: wrap;
  display: flex;
  justify-content: space-between; */
  align-items: center;
  padding: 0;
}

.left-button2 {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.right-button2 {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 1;
}

@media (max-width: 820px) {
  .buttoncontainer2 {
    display: block;
  }

  .left-button2 {
    margin-bottom: 16px;
  }
}

.flex_dropdown {
  margin-bottom: 14px;
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_inputText {
  margin-bottom: 14px;
  width: 70%;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}

.buttonGroup {
  border-radius: 32px;
  border: 1px solid #f1f1f1;
  background: #f8f8f8;
  display: flex;
  padding: 4px;
  align-items: center;
  max-width: 480px;
  justify-content: center;
  cursor: pointer;
  margin: 0 auto 24px auto;
}

.button_toggle {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  max-width: 235px;
}

.button_toggle p {
  color: #9e9e9e;
  font-family: Outfit;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 28.6px */
  margin: 0%;
}

.active {
  border-radius: 24px;
  background: var(--Primary-Active, #ac2887);
}

.active p {
  color: var(--white-high-100, #fff);
  font-family: Outfit;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%; /* 28.6px */
  margin: 0%;
}

.noFurtherFileContainer1 {
  width: -webkit-fill-available;
  padding: 12px 20px;
  background: #eaf7fe;
  border-radius: 8px;
  overflow: hidden;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  border-left: 6px solid rgb(122, 196, 236);
  margin-bottom: 44px;
}

.noFurtherFileSubContainer1 {
  flex: 1 1 0;
  color: #757575;
  font-size: 16px;
  font-family: Outfit;
  font-weight: 400;
  line-height: 20.8px;
  word-wrap: break-word;
}

.noFurtherFileContainer2 {
  width: -webkit-fill-available;
  padding: 12px 20px;
  background: #feeaea;
  border-radius: 8px;
  overflow: hidden;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  border-left: 6px solid #ec7a7a;
  margin-bottom: 44px;
}

.noFurtherFileSubContainer2 {
  flex: 1 1 0;
  color: #757575;
  font-size: 16px;
  font-family: Outfit;
  font-weight: 400;
  line-height: 20.8px;
  word-wrap: break-word;
}

.hideBtn {
  display: none;
}
</style>
